import { motion } from 'framer-motion';

export function PrivacyPolicy() {
  return (
    <div className="min-h-screen pt-32 pb-16 bg-brand-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl font-extrabold text-secondary-900 mb-8">Privacy Policy</h1>
          
          <div className="prose prose-blue max-w-none text-secondary-700">
            <p className="mb-4">Last Updated: {new Date().toLocaleDateString()}</p>
            
            <h2 className="text-2xl font-bold text-secondary-900 mt-8 mb-4">1. Information We Collect</h2>
            <p className="mb-4">
              At Wote InterCity, we collect information that you provide directly to us when you create an account, book a ticket, or communicate with our support team. This includes your name, email address, phone number, and payment information.
            </p>

            <h2 className="text-2xl font-bold text-secondary-900 mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="mb-4">
              We use the information we collect to provide, maintain, and improve our services, process your transactions, send you technical notices and support messages, and communicate with you about products, services, and events offered by Wote InterCity.
            </p>

            <h2 className="text-2xl font-bold text-secondary-900 mt-8 mb-4">3. Information Sharing</h2>
            <p className="mb-4">
              We do not share your personal information with third parties except as described in this privacy policy or as required by law.
            </p>

            <h2 className="text-2xl font-bold text-secondary-900 mt-8 mb-4">4. Security</h2>
            <p className="mb-4">
              We take reasonable measures to help protect information about you from loss, theft, misuse and unauthorized access, disclosure, alteration and destruction.
            </p>

            <h2 className="text-2xl font-bold text-secondary-900 mt-8 mb-4">5. Contact Us</h2>
            <p className="mb-4">
              If you have any questions about this Privacy Policy, please contact us at support@woteintercity.com.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
